import { type ObjectValuesUnionType } from '../utils/typing';

export const AuthServices = Object.freeze({
  LOGIN: 'core/authentication/login/',
  GENERATE: 'core/authentication/token/generate',
  REFRESH: 'core/authentication/token/refresh',
});
export type AuthService = ObjectValuesUnionType<typeof AuthServices>;

export const AuthServiceMethods = Object.freeze({
  GENERATE: 'GenerateToken',
  REFRESH: 'RefreshToken',
});

export const AuthMessages = Object.freeze({
  LOADED: 'wam://loaded',
  FORGOTPASSWORD: 'wam://forgotPassword',
  REGISTER: 'wam://subscribe',
  SUBMITTED: 'submitted',
  STORE_CREDENTIALS: 'storeCredentials',
});
export type AuthMessage = ObjectValuesUnionType<typeof AuthMessages>;

export const AuthActions = Object.freeze({
  RESET_PIN: 'reset-pin',
  RESET_FORM: 'reset-form',
});
export type AuthAction = ObjectValuesUnionType<typeof AuthActions>;

export const AuthTypes = Object.freeze({
  DEFAULT: 'default',
  DEFAULT_FULL: 'default-full',
  PIN: 'pin',
  BIRTHDATE_ONLY: 'birthdate-only',
});
export type AuthType = ObjectValuesUnionType<typeof AuthTypes>;

export type GenerateTokenQueryParams = {
  challenge: string;
  authorization_code: string;
  remote_ip: string | null;
};

export type GenerateTokenQuery = {
  method: typeof AuthServiceMethods.GENERATE;
  params: GenerateTokenQueryParams;
  ts: number;
  ns: 'core/authentication/token/generate';
  trace_id: string;
  id: string;
};

export type GenerateTokenResponseResult = {
  token: string;
  expiration_time: number;
  expiration_delay: number;
};

export type GenerateTokenResponse = {
  result: GenerateTokenResponseResult;
  id: string;
};

export type RefreshTokenQueryParams = {
  token: string;
};

export type RefreshTokenQuery = {
  method: typeof AuthServiceMethods.REFRESH;
  params: RefreshTokenQueryParams;
  ts: number;
  ns: 'core/authentication/token/refresh';
  trace_id: string;
  id: string;
};

export type RefreshTokenResponseResult = {
  token: string;
  expiration_time: number;
};

export type RefreshTokenResponse = {
  result: RefreshTokenResponseResult;
  id: string;
};
